import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types';

export default function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    const disabled = props.disabled || false;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };
  
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };
  
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };
  
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
  
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={(page === 0) || disabled}
          aria-label="Primeira Pagina"
          size="small"
          sx={{
            borderRadius: 2,
            mx: 0.25,
            '&:hover': { bgcolor: '#fff3e0' },
            '&:disabled': { opacity: 0.4 }
          }}
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={(page === 0) || disabled}
          aria-label="Pagina Anterior"
          size="small"
          sx={{
            borderRadius: 2,
            mx: 0.25,
            '&:hover': { bgcolor: '#fff3e0' },
            '&:disabled': { opacity: 0.4 }
          }}
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={(page >= Math.ceil(count / rowsPerPage) - 1) || disabled}
          aria-label="Proxima Pagina"
          size="small"
          sx={{
            borderRadius: 2,
            mx: 0.25,
            '&:hover': { bgcolor: '#fff3e0' },
            '&:disabled': { opacity: 0.4 }
          }}
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={(page >= Math.ceil(count / rowsPerPage) - 1) || disabled}
          aria-label="Ultima Pagina"
          size="small"
          sx={{
            borderRadius: 2,
            mx: 0.25,
            '&:hover': { bgcolor: '#fff3e0' },
            '&:disabled': { opacity: 0.4 }
          }}
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>      </Box>
    );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  disabled: PropTypes.bool
};